import React from 'react';
import S3Uploader from 'react-s3-uploader';
import hat from 'hat';
import moment from 'moment';
import { Progress } from 'reactstrap';
import PropTypes from 'prop-types';

class FileUploader extends React.Component {
    constructor(props) {
        super(props);

        this.uploader = null;

        this.state = {
            progress: null,
            progressStatus: null,
            uploaded: false,
            files: []
        };
    }

    componentDidMount() {
        if (this.props.files) {
            this.updateFiles(this.props.files);
        }
    }

    componentWillReceiveProps(props) {
        if (props.files) {
            this.updateFiles(props.files);
        }
    }

    updateFiles(files) {
        this.setState({ files });
    }

    onProgress(progress, progressStatus) {
        this.setState({ progress, progressStatus });
    }

    onError(error) {
        if (this.props.onError) {
            this.props.onError(error);
        }
    }

    onFinish(data) {
        let fileUrl = data.signedUrl.split('?').shift();

        let files = [];
        if (this.props.singleFile) {
            files = this.state.files.filter((file) => (file.newName === fileUrl.split('/').pop())).map((file) => {
                file.url = fileUrl;

                return file;
            });
        } else {
            files = this.state.files.map((file) => {
                if (file.newName === fileUrl.split('/').pop()) {
                    file.url = fileUrl;
                }

                return file;
            });
        }

        this.setState({ files, uploaded: true }, () => {
            if (this.props.onChange) {
                this.props.onChange(this.state.files.filter(file => file.url));
            }
        });
    }

    scrubFileName(filename) {
        let ext = filename.split('.').pop();
        let name = hat() + '' + moment().unix() + '.' + ext;

        let files = this.state.files;
        files.push({
            newName: name,
            originalName: filename,
            shortName: filename.length > 20 ? filename.substring(0, 17) + '...' + ext : filename
        });

        this.setState({ files });
        return name;
    }

    handleDelete(e, fileUrl) {
        e.preventDefault();
        this.uploader.clear();

        let files = this.state.files.filter(file => (file.url && file.url !== fileUrl));

        this.setState({ files }, () => {
            if (this.props.onChange) {
                this.props.onChange(this.state.files.filter(file => file.url));
            }
        });
    }

    uploadedFiles() {
        return this.state.files.filter(file => file.url).map((file, index) => {
            return (<p key={index}>{file.shortName}{' '}<a href="#" onClick={(e) => this.handleDelete(e, file.url)} style={{ color: 'red' }}>remove</a></p>);
        });
    }

    preProcess(file, next) {
        if (typeof BlueCompass !== 'undefined' && file.size > BlueCompass.s3filelimit) {
            alert("Your file is too large.");
        } else {
            next(file);
        }
    }

    accept() {
        if (this.props.accept) {
            return this.props.accept;
        }

        if (typeof BlueCompass !== 'undefined' && BlueCompass.s3type && BlueCompass.s3type === 'image') {
            return 'image/*';
        }

        return 'image/*,audio/*,video/*,*/*,.doc,.docx,.rtf,.pdf,.wav,.mp3,.wma,.mp4,.amr,.m4a,.avi,.mpg,.wmv,.mp4,.mov,.flv.m4v,.3gp,.3g2';
    }

    render() {
        return (
            <div className="row FileUploader">
                <div className="col-6">
                    <div className={'btn btn-primary fileinput-button'}>
                        <i className="glyphicon glyphicon-plus"></i>{' '}
                        <span data-toggle="tooltip" data-placement="right" title={this.props.tooltipText ? this.props.tooltipText : null}>{this.props.buttonText ? this.props.buttonText : 'Attach file'}
                            <S3Uploader
                                ref={node => (this.uploader = node)}
                                signingUrl="/api/s3/pre-signed-url"
                                signingUrlMethod="GET"
                                s3path={this.props.s3Path ? this.props.s3Path : 'rawFiles/'}
                                scrubFilename={(filename) => this.scrubFileName(filename)}
                                className="FileUploaderInput"
                                accept={this.accept()}
                                onProgress={(param1, param2) => this.onProgress(param1, param2)}
                                onError={(error) => this.onError(error)}
                                onFinish={(finish) => this.onFinish(finish)}
                                uploadRequestHeaders={{}}
                                contentDisposition="auto"
                                preprocess={(file, next) => this.preProcess(file, next)}
                            />
                        </span>
                    </div>
                </div>
                <div className="col-6">
                    <div>
                        <div>
                            {this.uploadedFiles()}
                            <div className={"FileUploaderStatus" + (this.state.progress === 100 ? ' fade' : '')}>
                                {this.state.progressStatus ?
                                    <p>{this.state.progressStatus}: {this.state.progress}%</p> : null}
                            </div>
                        </div>
                        {this.state.progress && this.state.progress !== 100 ? (
                            <Progress value={this.state.progress} />
                        ) : null}
                    </div>
                </div>
            </div>
        );
    }
}

FileUploader.propTypes = {
    onChange: PropTypes.func,
    onError: PropTypes.func,
    s3Path: PropTypes.string,
    accept: PropTypes.string,
    files: PropTypes.arrayOf(PropTypes.object),
    buttonText: PropTypes.string,
    singleFile: PropTypes.bool
};

export default FileUploader;